/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Reason_No_Event_CodeInputs */



/**
* | output |
* | --- |
* | "the event has no short code yet" |
*
* @param {Twda_Reason_No_Event_CodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_reason_no_event_code = /** @type {((inputs?: Twda_Reason_No_Event_CodeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Reason_No_Event_CodeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ce tournoi n'a pas encore de code court")
	if (locale === "es") return /** @type {LocalizedString} */ ("este torneo aún no tiene código corto")
	if (locale === "pt") return /** @type {LocalizedString} */ ("este torneio ainda não tem código curto")
	if (locale === "it") return /** @type {LocalizedString} */ ("questo torneo non ha ancora un codice breve")
	return /** @type {LocalizedString} */ ("the event has no short code yet")
});